export default __webpack_public_path__ + "static/media/about-img.07c03088.svg";